import { gql } from "apollo-boost";

export const GET_ORDERGROUPS = gql`
query OrderGroups($where: OrderGroupWhereInput!, $orderBy: OrderByInput, $skip: Int, $limit: Int) {
    orderGroups(where: $where, orderBy: $orderBy, skip: $skip, limit: $limit) {
      total
      data {
        customerLastName
        village
        district
        province
        id
        amount
        currency
        payment
        receivedMoney
        sumPrice
        sumPriceBaht
        sumPriceUsd
        rateUsd
        rateBaht
        totalPrice
        staff
        status
        staffLastname
        code
        createdAt
        updatedAt
        customerName
        paymentDate
        costTitle
        phone
        discountType
        discount
        cash
        transfer
        debt
        createdBy {
          id
          image
          firstName
          lastName
          phone
          role
          staffCode
        }
        shop {
          id
          address {
            village
            province
            district
          }
          image
        }
        orders {
          id
          amount
          amountFree
          phone
          productName
          currency
          originPrice
          price
          totalPrice
          totalPriceBaht
          totalPriceUsd
          type
          isPaymented
          isDeleted
          note
          createdAt
          updatedAt
          sortId
          stock {
            id
            currency
            price
            unit
            unitId {
              name
            }
            category {
              name
            }
            survivalId {
              survivalNumber
            }
          }
          options {
            name
            price
          }
        }
        userConfirm {
          name
        }
      }
    }
  }
`;

export const GET_ORDER_GROUPS_V2 = gql`
query OrderGroupsV2($where: OrderGroupWhereInput!, $orderBy: OrderByInput, $skip: Int, $limit: Int) {
    orderGroupsV2(where: $where, orderBy: $orderBy, skip: $skip, limit: $limit) {
      total
      data {
        checkBillDate
        customerLastName
        village
        district
        province
        id
        amount
        currency
        payment
        receivedMoney
        sumPrice
        sumPriceBaht
        sumPriceUsd
        rateUsd
        rateBaht
        totalPrice
        staff
        status
        staffLastname
        type
        code
        transfer
        cash
        debt
        isPaymented
        createdAt
        updatedAt
        createdBy {
          id
          image
          firstName
          lastName
          phone
          role
          staffCode
        }
        customerName
        phone
        discount
        discountType
        shippingCost
        addressCf
        costTitle
        logistic
        destinationLogistic 
        deliveryMethod
        note
        userConfirm {
          name
          lastname
          phone
          userCode
          address {
            district
            province
            village
          }
          userType {
            id
            isOpen
            name
          }
        }
        shop {
          id
          address {
            village
            province
            district
          }
          image
        }
        orders {
          id
          amount
          amountFree
          phone
          productName
          currency
          originPrice
          price
          totalPrice
          totalPriceBaht
          totalPriceUsd
          type
          isDeleted
          note
          createdAt
          updatedAt
          sortId
          options {
            name
            price
          }
          stock {
            id
            currency
            image
            price
            unit
            unitId {
              name
            }
            categoryName
            category {
              name
            }
            survivalId {
              survivalNumber
            }
            size
            dimension {
              length
              width
              height
              weight
            }
          }
        }
      }
    }
  }
`


export const GET_ORDERGROUP = gql`
query OrderGroup($where: OrderGroupWhereInputOne!) {
  orderGroup(where: $where) {
    id
    amount
    shop {
      id
      name
      phone
    }
    code
    status
    totalPrice
    sumPrice
    sumPriceBaht
    sumPriceUsd
    receivedMoney
    rateBaht
    rateUsd
    currency
    addressCf
    costTitle
    discount
    payment
    paymentDate
    shippingCost
    addressCf
    createdBy {
      id
      image
      firstName
      lastName
      phone
      role
      staffCode
    }
    logistic
    deliveryMethod
    orders {
      id
      amount
      amountFree
      phone
      productName
      stock {
        id
        price
        originPrice
        currency
        size
        amount
        image
        name
        unit
        unitId {
          id
          name
        }
        survivalId {
          survivalNumber
        }
        dimension {
          length
          width
          height
          weight
        }
      }
      currency
      price
      originPrice
      totalPrice
      totalPriceBaht
      totalPriceUsd
      cfName
      status
      payment
      type
      isPaymented
      sortId
      isDeleted
      note
      children {
        id
        stockOptionItem
        stock {
          id
          name
          amount
          price
          size
          dimension {
            length
            width
            height
            weight
          }
          currency
        }
        code
        type
        platform
        status
        currency
        tag
        productName
        originPrice
        price
        amount
        volume
        rate
        totalPrice
        convertPrice
      }
      options {
        name
        price
      }
    }
    userConfirm {
      id
      name
      lastname
      phone
      userCode
      address {
        district
        province
        village
      }
    }
  }
}
`

export const GET_ORDERGROUPV2 = gql`
query OrderGroupV2($where: OrderGroupWhereInputOne!) {
  orderGroupV2(where: $where) {
    id
    amount
    shop {
      id
      name
      phone
    }
    code
    status
    totalPrice
    sumPrice
    sumPriceBaht
    sumPriceUsd
    currency
    addressCf
    costTitle
    discount
    payment
    paymentDate
    shippingCost
    addressCf
    createdBy {
      id
      image
      firstName
      lastName
      phone
      role
      staffCode
    }
    logistic
    deliveryMethod
    orders {
      id
      amount
      amountFree
      phone
      productName
      stock {
        id
        price
        originPrice
        currency
        size
        amount
        image
        name
        unit
        unitId {
          id
          name
        }
        survivalId {
          survivalNumber
        }
        dimension {
          length
          width
          height
          weight
        }
      }
      currency
      price
      originPrice
      totalPrice
      totalPriceBaht
      totalPriceUsd
      cfName
      status
      payment
      type
      isPaymented
      sortId
      isDeleted
      note
      children {
        id
        stockOptionItem
        stock {
          id
          name
          amount
          price
          size
          dimension {
            length
            width
            height
            weight
          }
          currency
        }
        code
        type
        platform
        status
        currency
        tag
        productName
        originPrice
        price
        amount
        volume
        rate
        totalPrice
        convertPrice
      }
      options {
        name
        price
      }
    }
    userConfirm {
      id
      name
      lastname
      phone
      userCode
      address {
        district
        province
        village
      }
    }
  }
}
`
export const GET_GEN_CODE_ORDER_GROUP = gql`
query OrderGroups($where: OrderGroupWhereInput!, $orderBy: OrderByInput, $skip: Int, $limit: Int) {
    orderGroups(where: $where, orderBy: $orderBy, skip: $skip, limit: $limit) {
      total
    }
  }
`

export const GENERATE_CODE = gql`
  query GenerateCode($where: OrderGroupWhereInput!) {
    generateCode(where: $where) {
      status
      msg
      tag
    }
  }
`;

export const GET_INDEBTED = gql`
query Indebteds($where: OrderGroupWhereInput!, $limit: Int, $orderBy: OrderByInput, $skip: Int) {
  indebteds(where: $where, limit: $limit, orderBy: $orderBy, skip: $skip) {
    total
    totalAmount
    totalSumPrice
    data {
      _id
      customerId
      customerName
      customerLastName
      phone
      village
      district
      province
      billQty
      amount
      sumPrice
    }
  }
}

`
